ixModuleRouting("impactx.complaintconfiguration", {
    "/complaintconfigurationlist": {
        template: "<ixa-complain-configuration-list></ixa-complain-configuration-list>",
        templateUrl:
            "modules/complaintconfiguration/templates/complaintconfigurationlist.html",
        controller: "ComplaintConfigurationListCtrl",
        controllerAs: "complaintConfigurationListCtrl",
        process: "ComplaintConfiguration",
        workspace: "content",
    },
    "/complaintconfiguration/:id": {
        template: "<ixa-complain-configuration-detail></ixa-complain-configuration-detail>",
        templateUrl:
            "modules/complaintconfiguration/templates/complaintconfiguration.html",
        controller: "ComplaintConfigurationCtrl",
        controllerAs: "complaintConfigurationCtrl",
        process: "ComplaintConfiguration",
        workspace: "content",
    },
    "/complaintconfiguration/new/:id": {
        template: "<ixa-complain-configuration-detail></ixa-complain-configuration-detail>",
        templateUrl:
            "modules/complaintconfiguration/templates/complaintconfiguration.html",
        controller: "ComplaintConfigurationCtrl",
        controllerAs: "complaintConfigurationCtrl",
        process: "ComplaintConfiguration",
        workspace: "content",
    },
});
